'use strict';

var ajax =  require('../../ajax'),
    util = require('../../util');

var updateContainer = function (data, $target) {
    var $parentMain = $target.closest('#pdpMain');
    var $availabilityMsg = $parentMain.find('.availability .availability-msg');
    var message; // this should be lexically scoped, when `let` is supported (ES6)
    if (!data) {
        $availabilityMsg.html(Resources.ITEM_STATUS_NOTAVAILABLE);
        return;
    }
    $availabilityMsg.empty();
    // Look through levels ... if msg is not empty, then create span el
    if (data.levels.IN_STOCK > 0) {
        if(data.showMaxQtyMsg && data.levels.NOT_AVAILABLE === 0){
            message=data.maxQtyReachedMsg;
        }else if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            // Just in stock
            //Comented cause we don't want the app to do anything if the message is in stock.
            // message = Resources.IN_STOCK;
            message = '';
        } else {
            // In stock with conditions ...
            message = data.inStockMsg;
        }

        if(data.showMaxQtyMsg && data.levels.NOT_AVAILABLE === 0){
            $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
        }else {
            $availabilityMsg.append('<p class="in-stock-msg">' + message + '</p>');
        }
        
    }
    if (data.levels.PREORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.PREORDER;
        } else {
            message = data.preOrderMsg;
        }
        $availabilityMsg.append('<p class="preorder-msg">' + message + '</p>');
    }
    if (data.levels.BACKORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.BACKORDER;
        } else {
            message = data.backOrderMsg;
        }
        $availabilityMsg.append('<p class="backorder-msg">' + message + '</p>');
    }
    if (data.inStockDate !== '') {
        $availabilityMsg.append('<p class="in-stock-date-msg">' + String.format(Resources.IN_STOCK_DATE, data.inStockDate) + '</p>');
    }
    if (data.levels.NOT_AVAILABLE > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
            message = Resources.NOT_AVAILABLE;
        } else {
            message = data.reduceQtyMsg;
        }
        $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
        var user = dataLayer.find(o => o.user != null).user;
		dataLayer.push({
		    'event': 'custom_event',
		    'eventCategory': 'PDP',
		    'eventAction': 'product_out_of_stock',
		    'eventLabel': 'product out of stock - ' + product.id, //product id i.e. 57_2MM598_513V
			"productName": product.name,
			"country": window.GlobalAttributes.COUNTRY,
			"language": window.GlobalAttributes.LANGUAGE,
			"screenName" : 'PDP',
			"userType": user.user_id!='' ? 'logged-in' : 'logged-out',
			"userId": user.user_id!=''? user.user_id : ''  
		});
    }
};

var getAvailability = function () {
    var target = this;
    if( !target.value ) {
        return;
    }

    ajax.getJson({
        url: util.appendParamsToUrl(Urls.getAvailability, {
            pid: $(target).closest('form').find('input[name="pid"]').val(),
            Quantity: $(target).val()
        }),
        callback: function(data) {
            updateContainer(data, $(target));
        }
    });
};
var init = function() {
	var $mainElement = $('body');
    $mainElement.off('change.getAvailability').on('change.getAvailability', '.pdpForm input[name="Quantity"]', getAvailability);
}
module.exports = {
		init: init,
		updateContainer: updateContainer
};




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/availability.js